// src/components/games/GameLinks.js

function GameLinks({ links = {} }) {
  const LINK_LABELS = {
    homepage: "공식 홈페이지",
    forum: "커뮤니티 포럼",
    discord: "디스코드",
    twitter: "트위터/X",
    youtube: "유튜브"
  };

  return (
    <div className="bg-neutral-800 p-4 rounded">
      <h4 className="text-md font-semibold mb-2">관련 링크</h4>
      <ul className="space-y-2 text-sm text-blue-400">
        {Object.entries(LINK_LABELS).map(([key, label]) =>
          links[key] ? (
            <li key={key}>
              <a href={links[key]} target="_blank" rel="noreferrer">
                {label} →
              </a>
            </li>
          ) : null
        )}
      </ul>
    </div>
  );
}

export default GameLinks;
